export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/scrollIcon.9cd0a8e0.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};